import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromAddOrganization from '@store/reducers/add-organization/add-organization.reducer';

export const selectAddOrganizationState = createFeatureSelector<fromAddOrganization.State>(
  fromAddOrganization.addOrganizationFeatureKey
);

export const selectTypeFilterSearch = createSelector(
    selectAddOrganizationState,
    (state: fromAddOrganization.State) => {
        return state.typeSearch
    }
);

export const selectOrganizationName = createSelector(
    selectAddOrganizationState,
    (state: fromAddOrganization.State) => {
        return state.name
    }
);

export const selectOrganizationID = createSelector(
    selectAddOrganizationState,
    (state: fromAddOrganization.State) => {
        return state.organizationID
    }
);

export const selectIsTestOrganization = createSelector(
    selectAddOrganizationState,
    (state: fromAddOrganization.State) => state.isTestOrganization
);

export const selectOrganizationLegacyId = createSelector(
    selectAddOrganizationState,
    (state: fromAddOrganization.State) => {
        return state.legacyOrganizationID
    }
);

export const selectStateFilterSearch = createSelector(
    selectAddOrganizationState,
    (state: fromAddOrganization.State) => {
        return state.stateSearch
    }
);
export const selectUpdateOrganizationInfo = createSelector(
    selectAddOrganizationState,
    (state: fromAddOrganization.State) => ({
        ID: state.organizationID,
        Name: state.name,
        OrganizationTypeID: state.type,
        LegacyOrganizationID: state.legacyOrganizationID,
        CRMID: state.crmID,
        AddressLine1: state.address,
        AddressLine2: state.addressB,
        City: state.city,
        StateID: state.state,
        PostalCode: state.zipCode,
        isValid: state.isValid
    })
);

export const selectAddOrganizationForm = createSelector(
    selectAddOrganizationState,
    (state: fromAddOrganization.State)=> ({
        name: state.name,
        type: state.type,
        organizationID: state.organizationID,
        legacyOrganizationID: state.legacyOrganizationID,
        crmID: state.crmID,
        address: state.address,
        addressB: state.addressB,
        zipCode: state.zipCode,
        city: state.city,
        state: state.state
    })
);


// TODO State filtering might be on the api or DB side
export const selectAddOrganizationFilteredStates = createSelector(
    selectAddOrganizationState,
    (state: fromAddOrganization.State) => {
        return state.statesDropdown
    }
)
// TODO Cities filtering might be on the api or DB side

// TODO Type filtering might be on the api or DB side
export const selectAddOrganizationFilteredTypes = createSelector(
    selectAddOrganizationState,
    (state: fromAddOrganization.State) => {
        return state.organizationTypesDropdown// .filter((type) => {
        //     return type.value.toLowerCase().includes(state.typeSearch.toLowerCase())
        // })

    }
)
